import { render, staticRenderFns } from "./AutoAssignVendorDialog.vue?vue&type=template&id=1a74e8c2"
import script from "./AutoAssignVendorDialog.vue?vue&type=script&lang=ts"
export * from "./AutoAssignVendorDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports